import { useMemo } from 'react';
import { CardTypesEnum, useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { OrganizationTypes } from '@/common/constants';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { EnrolledBlockPayload, EnrolledBlockPlanCategoriesItem } from '../../Dashboard.type';

const QUERY_KEY = 'ENROLLED_BLOCK_QUERY';

const useEnrolledBlockQuery = () => {
  const {
    observingOrganization: { type, id },
  } = useCurrentOrganization();

  const isSystemLevel = useMemo(() => type === OrganizationTypes.system, [type]);

  const { isLoading, data, isSuccess } = useQuery(
    [QUERY_KEY, id, type],
    () => api.get(API_URL.METRICS_PLAN_ENROLLMENT),
    {
      enabled: !isSystemLevel,
    }
  );

  const formattedData = useMemo<EnrolledBlockPayload | null>(() => {
    const responseData = data?.data;

    if (responseData) {
      const list =
        responseData?.enrolled_account_type_counts?.map((item) => {
          const newItem: EnrolledBlockPlanCategoriesItem = {
            count: item.employees_count,
            accountType: item.account_type as unknown as CardTypesEnum,
            accountName: item.account_description,
          };
          return newItem;
        }) || [];
      const sorted = _.sortBy(list, (item) => item.count).reverse();

      return {
        enrolledCount: responseData.enrolled_count || 0,
        unenrolledCount: responseData.unenrolled_count || 0,
        planCategories: sorted,
      };
    }

    return null;
  }, [data?.data]);

  const isEmpty = useMemo(() => {
    if ((isSuccess && !formattedData) || isSystemLevel) {
      return true;
    }
    return false;
  }, [formattedData, isSuccess, isSystemLevel]);
  return {
    isLoading,
    isEmpty,
    isSuccess,
    data: formattedData,
  };
};
export default useEnrolledBlockQuery;
